import type { JSX } from 'react';

import { TooltipProvider } from '@/components/ui/tooltip';

import WebhooksAvailablePanelContent from './WebhooksAvailablePanelContent';

interface WebhooksAvailablePanelProps {
  projectId: number;
  /** Subproyectos del maestro, para asociar el webhook (opcional). */
  subProjects?: { id: number; name: string }[];
}

const EMPTY_SUB_PROJECTS: { id: number; name: string }[] = [];

const WebhooksAvailablePanel = ({
  projectId,
  subProjects = EMPTY_SUB_PROJECTS,
}: WebhooksAvailablePanelProps): JSX.Element => {
  return (
    <TooltipProvider delayDuration={300}>
      <WebhooksAvailablePanelContent projectId={projectId} subProjects={subProjects} />
    </TooltipProvider>
  );
};

export default WebhooksAvailablePanel;
